// src/app/core/http-loading.token.ts
import { HttpContextToken } from '@angular/common/http';

// Por defecto NO rastrea; sólo si lo activas por solicitud.
export const TRACK_LOADING = new HttpContextToken<boolean>(() => false);